import { PriceListItemCombinedProps } from './types';

const usePresenter = (props: PriceListItemCombinedProps): PriceListItemCombinedProps => {
  return props;
};

export default usePresenter;
